import { Accordion, AppShell, Fieldset, Input, Tabs } from "@mantine/core";
import accordion from "./accordion.module.css";
import appshell from "./appshell.module.css";
import fieldset from "./fieldset.module.css";
import tabs from "./tabs.module.css";
import { ADMIN_HEADER_HEIGHT, theme } from "./theme";
theme.components = {
  AppShell: AppShell.extend({
    classNames: appshell,
    defaultProps: {
      header: {
        height: ADMIN_HEADER_HEIGHT,
      },
    },
  }),
  Accordion: Accordion.extend({
    classNames: accordion,
  }),
  Tabs: Tabs.extend({
    classNames: tabs,
  }),
  Input: Input.extend({
    defaultProps: {
      size: "xs",
    },
  }),
  Fieldset: Fieldset.extend({
    classNames: fieldset,
  }),
};
export { theme };
